export default __webpack_public_path__ + "static/media/404.00314c25.gif";